<div class="flex flex-column p-2 gap-2" [formGroup]="form">
  <app-input-datetime name="dataOraPrelievo" [form]="form"  [minDate]="puntoCamp?.dataInizioValidita!" [maxDate]="puntoCamp?.dataFineValidita!"></app-input-datetime>
  <app-input-text name="codicePrelievo" label="Codice" [form]="form"></app-input-text>
  <app-input-text name="entePrelievo" label="Ente" [form]="form"></app-input-text>
</div>
